import { Select as AntdSelect } from 'antd';
import type { FC, ReactNode } from 'react';

interface SelectProps {
  children?: ReactNode;
  onChange?: (value: string) => void;
  value?: string;
  defaultValue?: string;
  placeholder?: string;
  className?: string;
  [key: string]: any;
}

export const Select: FC<SelectProps> = ({ children, onChange, className = '', ...selectProps }) => {
  // Convert children to options if they are option elements
  const options = children
    ? Array.isArray(children)
      ? children.map((child: any) => ({
          value: child.props.value,
          label: child.props.children,
        }))
      : [
          {
            value: (children as any).props.value,
            label: (children as any).props.children,
          },
        ]
    : [];

  return <AntdSelect className={className} options={options} onChange={onChange} {...selectProps} />;
};

export default Select;
